import { z } from 'zod';
import {
  EMAIL_REG_EXP,
  PHONE_REG_EXP,
} from '../../../1_shared/constants/regularExpressions';

export const ClientCreationFormSchema = z.object({
  nickname: z.string().min(1, { message: 'Укажите имя или псевдоним' }),
  phone: z
    .string()
    .min(3, { message: 'Укажите номер телефона' })
    .regex(PHONE_REG_EXP, 'Номер не соответствует формату'),
  email: z
    .string()
    .optional()
    .refine(data => (data ? EMAIL_REG_EXP.test(data) : true), {
      message: 'Не соответствует формату почты',
    }),
});

export type TClientCreationForm = z.infer<typeof ClientCreationFormSchema>;
